module.exports = __webpack_public_path__ + "static/media/LMS-ELEARNING.9f393223.png";